import { createSlice } from "@reduxjs/toolkit";



const initialState = {
    selected: null,
    expandedBar: 'collapsed',
    pagination: {
        start: 0,
        limit: 20,
        page: 1
    }
};

export const persistence = {
    fields: ['expandedBar']
};

const licenceSlice = createSlice({
    name: 'licence',
    initialState,
    reducers: {
        setSelected: (state, {payload}) => { state.selected = payload; },
        resetLicence: (state) => { state.selected =  null; },
        setPagination: (state, {payload}) => { state.pagination = payload; },
        resetPagination: (state) => { state.pagination = {start: 0, limit: 10, page: 1}; },
        setExpandedBar: (state, {payload}) => { state.expandedBar = payload; }
    }
});



export const {
    setSelected,
    setPagination,
    resetLicence,
    resetPagination,
    setExpandedBar
} = licenceSlice.actions;

export default licenceSlice.reducer;